<script>
import vSelect from 'vue-select'
export default {
  data () {
    return {
      dados: null,
      optionsFilter: [],
      timerFiltro: 7
    }
  },
  components: { vSelect },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('model', newValue)
      }
    }
  },
  methods: {
    toSlug: function (value) {
      let str = value.replace(/^\s+|\s+$/g, '')
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      let from = 'ãàáäâèéëêìíïîõòóöôùúüûñç·/_,:;'
      let to = 'aaaaaeeeeiiiiooooouuuunc------'
      for (let i = 0; i <= from.length; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str.replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-')
      return str
    },
    filtra: function (query, loading) {
      clearTimeout(this.timerFiltro)
      if (query.length > 1) {
        this.timerFiltro = setTimeout(() => {
          loading(true)
          query = this.toSlug(query)
          this.optionsFilter = []
          this.options.forEach(elto => {
            let label = this.toSlug(elto.label)
            if (label.search(query) > -1) {
              this.optionsFilter.push(elto)
            }
          })
          loading(false)
        }, 500)
      } else {
        this.optionsFilter = this.options
      }
    }
  },
  props: {
    value: {
      type: Object,
      default: null,
      required: false
    },
    input: {
      type: Function,
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    texto: {
      type: String,
      required: true
    },
    vazio: {
      type: String,
      required: false
    },
    filterable: {
      type: Boolean,
      required: false,
      default: true
    },
    funcao: {
      type: Function,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    options: function () {
      this.optionsFilter = this.options
    }
  },
  mounted () {
    this.optionsFilter = this.options
  }

}
</script>
<template>
  <div>
    <v-select :on-search="filtra" v-model="model" @input="input" :options="optionsFilter" :placeholder="texto" :filterable="false" :disabled="disabled" >
      <span slot="no-options">
        {{vazio}}
      </span>
    </v-select>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// search-select.vue?42525176